import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import { fetchSignupFormQuestions } from "./thunk";

export interface SignupFormQuestionsState {
  signupFormQuestions: [];
  error: string | null;
  status: "idle" | "fetching" | "saving";
}

const initialState: SignupFormQuestionsState = {
  signupFormQuestions: [],
  error: null,
  status: "idle"
};

export const signupFormQuestionsSlice = createSlice({
  name: "signupFormQuestions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[signupFormQuestionsSlice.name]
        };
      })
      .addCase(fetchSignupFormQuestions.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchSignupFormQuestions.fulfilled, (state, action) => {
        state.status = "idle";
        state.signupFormQuestions = action.payload;
      })
      .addCase(fetchSignupFormQuestions.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});
